export type RemoteService = {};
